__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "data-import-microapp";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("launchdarkly-vue-client-sdk", "2.5.3", () => (Promise.all([__webpack_require__.e(481), __webpack_require__.e(540)]).then(() => (() => (__webpack_require__(54481))))));
			register("pinia", "4.1.0", () => (Promise.all([__webpack_require__.e(197), __webpack_require__.e(824)]).then(() => (() => (__webpack_require__(68197))))));
			register("vue-i18n", "11.4.17", () => (Promise.all([__webpack_require__.e(583), __webpack_require__.e(695)]).then(() => (() => (__webpack_require__(99964))))));
			register("vue", "3.5.44", () => (__webpack_require__.e(539).then(() => (() => (__webpack_require__(50539))))));
			register("vuetify", "4.3.1", () => (Promise.all([__webpack_require__.e(155), __webpack_require__.e(682), __webpack_require__.e(150), __webpack_require__.e(71), __webpack_require__.e(556)]).then(() => (() => (__webpack_require__(37556))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};